import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import Zoom from "react-reveal/Zoom";
import { Container, Row, Col, Button } from "react-bootstrap";
import Jello from "react-reveal/Jello";
import { useParams, useHistory } from "react-router-dom";

function GetHourDiff(pStartHour, pEndHour) {
  var res = "";
  var aTmp = "";
  aTmp = pStartHour.split(":");
  var nStartMin = Number(aTmp[0]) * 60 + Number(aTmp[1]);
  aTmp = pEndHour.split(":");
  var nEndMin = Number(aTmp[0]) * 60 + Number(aTmp[1]);
  var nDiff = 0;
  if (nStartMin > nEndMin) {
    nDiff = nStartMin - nEndMin;
  } else {
    nDiff = nEndMin - nStartMin;
  }
  var nDiffMin = 0;
  var nDiffHour = 0;
  if (nDiff > 59) {
    nDiffMin = nDiff % 60;
    nDiffHour = (nDiff - nDiffMin) / 60;
  } else {
    nDiffMin = nDiff;
  }
  if (nDiffHour < 10) res += "0";
  res += nDiffHour;
  res += ":";
  if (nDiffMin < 10) res += "0";
  res += nDiffMin;
  return res;
}

function Ritardo() {
  let { idPrenotazione } = useParams();
  let history = useHistory();
  const [parcheggi, setParcheggi] = useState([]);
  /* const [ritiro, handleClick] = useState(false); */
  const [destinazione, clickDestinazione] = useState(false);
  const [costo, setCosto] = useState(0);
  const [dataFine, setDataFine] = useState("");
  const [nuovaData, setNuovaData] = useState("");
  const [oraFine, setOraFine] = useState("");
  const [nuovaOra, setNuovaOra] = useState("");
  const [rilascio, setRilascio] = useState("");
  const [restituzione, setRestituzione] = useState("");
  const [modello, setModello] = useState("");
  const [motivazioneRitardo, setMotivazioneRitardo] = useState("");
  const [nuovoCosto, setNuovoCosto] = useState(0);
  const [vecchiaDataFine, setVecchiaDataFine] = useState("");
  const [vecchiaOraFine, setVecchiaOraFine] = useState("");

  const initialValues = {
    data_noleggio_iniziale: "",
    orario_noleggio_iniziale: "",
    data_noleggio_finale: "",
    orario_noleggio_finale: "",
    luogo_rilascio_ritiro: "",
    modello: "",
    presenza_autista: "",
    destinazione: "",
    numero_carta: "",
    costo_prenotazione: 0,
  };

  useEffect(() => {
    axios
      .get(
        `https://website-8bit-motors.herokuapp.com/prenotazioni/ritardo/${idPrenotazione}`
      )
      .then((response) => {
        setDataFine(response.data.data_noleggio_finale);
        setOraFine(response.data.orario_noleggio_finale);
        setCosto(response.data.costo_prenotazione);
        setModello(response.data.modello);
      });
    axios
      .get(
        "https://website-8bit-motors.herokuapp.com/parcheggi/ottieniParcheggi"
      )
      .then((response) => {
        setParcheggi(response.data);
      });
  }, []);

  const changeValue2 = () => {
    document.getElementById("destinazione").value = "";
    document.getElementById("destinazione_personalizzata").value = "";
    const errorePer2 = document.getElementById("destinazione_personalizzata");
    const errore2 = document.getElementById("destinazione");
    if (errore2.hasAttribute("required")) {
      errore2.attributes.removeNamedItem("required");
      const required = document.createAttribute("required");
      errorePer2.attributes.setNamedItem(required);
    } else {
      errorePer2.attributes.removeNamedItem("required");
      const required = document.createAttribute("required");
      errore2.attributes.setNamedItem(required);
    }
  };

  const onSubmit = () => {
    if (
      nuovoCosto === 0 ||
      nuovaData !== vecchiaDataFine ||
      nuovaOra !== vecchiaOraFine
    ) {
      alert("Calcolare il prezzo prima d'inviare");
    } else if (dataFine > nuovaData) {
      alert("Inserire una data successiva o uguale a quella precedente");
    } else {
      axios
        .post(
          `https://website-8bit-motors.herokuapp.com/prenotazioni/ritardo/${idPrenotazione}`,
          { nuovaData, nuovaOra, restituzione, nuovoCosto, motivazioneRitardo }
        )
        .then(() => {
          axios
            .post(
              `https://website-8bit-motors.herokuapp.com/incarichi/ritardo/${idPrenotazione}`,
              { nuovaData, nuovaOra, restituzione, motivazioneRitardo }
            )
            .then(() => {
              history.push("/");
            });
        });
    }
  };

  const pagamento = () => {
    axios
      .get(
        `https://website-8bit-motors.herokuapp.com/veicoli/specifiche/${modello}/ritardo`
      )
      .then((response) => {
        const tariffa = response.data.tariffa;

        let data1 = new Date(dataFine);
        let data2 = new Date(nuovaData);

        if (data2 === "" || nuovaOra === "") {
          alert("Devi inserire la data iniziale e la data finale");
          setNuovoCosto(0);
        } else {
          let differenza = parseInt((data2 - data1) / (1000 * 3600));
          if (differenza < 0) {
            alert("Inserire un periodo di noleggio valido");
          } else {
            let differenza2 = GetHourDiff(oraFine, nuovaOra);
            let differenza3 = parseInt(differenza2.slice(0, 2));
            let somma;

            if (differenza === 0) {
              if (oraFine.split(":")[0] > nuovaOra.split(":")[0]) {
                alert(
                  "Selezionare un orario superiore a quello indicato precedentemente"
                );
              } else {
                somma = differenza + differenza3;

                let prezzo = costo + tariffa * somma;
                if (prezzo > 0) {
                  setNuovoCosto(prezzo);
                } else {
                  alert("Errore: Controlla i campi compilati!!!!!");
                  setNuovoCosto(0);
                }
              }
            } else {
              if (oraFine.split(":")[0] > nuovaOra.split(":")[0]) {
                somma = differenza - differenza3;
              } else {
                somma = differenza + differenza3;
              }

              let prezzo = costo + tariffa * somma;
              if (prezzo > 0) {
                setNuovoCosto(prezzo);
              } else {
                alert("Errore: Controlla i campi compilati!!");
                setNuovoCosto(0);
              }
            }
          }
          setVecchiaDataFine(nuovaData);
          setVecchiaOraFine(nuovaOra);
        }
      });
  };

  return (
    <div>
      {console.log(modello)}
      <Container fluid className="text-center">
        <Jello>
          {/* SEZIONE BANNER */}
          <Container
            fluid
            className="head-banner text-white text-center"
            id="banner_accesso"
          >
            <Row>
              <Col>
                <h1>
                  <strong>8-Bit Motors</strong>
                </h1>
              </Col>
            </Row>
          </Container>
        </Jello>

        <h2 className="mt-3">Motiva il tuo ritardo</h2>
        <h3>Nel caso in cui sorga un imprevisto segnala il tuo ritardo!</h3>

        <Container>
          <Formik initialValues={initialValues} onSubmit={onSubmit}>
            <Form>
              <Row>
                <Col>
                  <label className="mt-2 form_registrazione">
                    Motivazione:{" "}
                  </label>
                  <ErrorMessage name="data_noleggio_finale" component="span" />
                  <Field
                    className="mt-2 form-control input_registrazione"
                    type="text"
                    id="motivazione"
                    name="motivazione"
                    placeholder="Es. Ruota bucata"
                    onChange={(event) => {
                      setMotivazioneRitardo(event.target.value);
                    }}
                    required
                  />

                  <label className="mt-2 form_registrazione">
                    Data Noleggio (Finale):{" "}
                  </label>
                  <ErrorMessage name="data_noleggio_finale" component="span" />
                  <Field
                    className="mt-2 form-control input_registrazione"
                    value={nuovaData}
                    as="input"
                    type="date"
                    id="data_noleggio_finale"
                    name="data_noleggio_finale"
                    placeholder="gg/mm/aaaa"
                    onChange={(event) => {
                      setNuovaData(event.target.value);
                    }}
                    required
                  />
                </Col>

                <Col>
                  <label className="mt-2 form_registrazione">
                    Orario Noleggio (Finale):{" "}
                  </label>
                  <ErrorMessage name="data_noleggio_finale" component="span" />
                  <Field
                    className="mt-2 form-control input_registrazione"
                    value={nuovaOra}
                    as="input"
                    type="time"
                    id="orario_noleggio_finale"
                    name="orario_noleggio_finale"
                    placeholder=""
                    onChange={(event) => {
                      setNuovaOra(event.target.value);
                    }}
                    required
                  />

                  <Zoom left opposite collapse when={!destinazione}>
                    <label className="mt-2 form_registrazione">
                      {" "}
                      Nuova Destinazione (o luogo di restituzione):{" "}
                    </label>
                    <select
                      className="mt-2 form-control input_registrazione"
                      id="destinazione"
                      name="destinazione"
                      onChange={(event) => {
                        setRestituzione(event.target.value);
                      }}
                      required
                    >
                      <option value="" name="destinazione">
                        {" "}
                        ...{" "}
                      </option>
                      {parcheggi.map((value, key) => {
                        return (
                          <option
                            key={key}
                            value={value.luogo}
                            name="destinazione"
                          >
                            {" "}
                            {value.luogo}{" "}
                          </option>
                        );
                      })}
                      ;
                    </select>
                  </Zoom>

                  <Button
                    className="mt-2 mb-2"
                    variant="warning"
                    onClick={() => {
                      clickDestinazione(!destinazione);
                      changeValue2();
                    }}
                  >
                    {" "}
                    {destinazione
                      ? "Scegli Tra i Nostri Parcheggi"
                      : "Imposta Luogo di Rilascio Personalizzato"}{" "}
                  </Button>
                  <Zoom left opposite cascade collapse when={destinazione}>
                    <input
                      className="mt-2 form-control input_registrazione"
                      id="destinazione_personalizzata"
                      type="text"
                      name="destinazione"
                      placeholder="Es. Via dante..."
                      onChange={(event) => {
                        setRestituzione(event.target.value);
                      }}
                    />
                  </Zoom>
                </Col>
              </Row>

              <Button variant="info" className="mt-5" onClick={pagamento}>
                {" "}
                Calcola Prezzo{" "}
              </Button>
              <h3 value={nuovoCosto} required>
                € {nuovoCosto}
              </h3>

              <Button type="submit" variant="success">
                {" "}
                Invia{" "}
              </Button>
            </Form>
          </Formik>
        </Container>
      </Container>
    </div>
  );
}

export default Ritardo;
